import React from "react";

const MessageKeywords = ({ setMessage }) => {

  const insertTagAtMessageSegments = (areaId, text) =>{
    var txtarea = document.getElementById(areaId);
    if (!txtarea) {
        return;
    }
    // if (txtarea.value.length < 188) {
    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
        "ff" : (document.selection ? "ie" : false));
    if (br == "ie") {
        txtarea.focus();
        var range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        strPos = range.text.length;
    } else if (br == "ff") {
        strPos = txtarea.selectionStart;
    }
    var front = (txtarea.value).substring(0, strPos);
    var back = (txtarea.value).substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    let WelcomeMessage = txtarea.value;
    WelcomeMessage = WelcomeMessage.replace(/{first_name}/g, "");
    WelcomeMessage = WelcomeMessage.replace(/{last_name}/g, "");
    WelcomeMessage = WelcomeMessage.replace(/{contest_place}/g, "");
    WelcomeMessage = WelcomeMessage.replace(/{date}/g, "");
    WelcomeMessage = WelcomeMessage.replace(/{date_time}/g, "");
    // this.setState({ default_message_text: txtarea.value });
    setMessage(txtarea.value)
    // console.log("txtarea.value", txtarea.value)
    if (br == "ie") {
        txtarea.focus();
        var ieRange = document.selection.createRange();
        ieRange.moveStart('character', -txtarea.value.length);
        ieRange.moveStart('character', strPos);
        ieRange.moveEnd('character', 0);
        ieRange.select();
    } else if (br == "ff") {
        txtarea.selectionStart = strPos;
        txtarea.selectionEnd = strPos;
        txtarea.focus();
    }
    txtarea.scrollTop = scrollPos;
}
  return (
  <div className="keywords-wrapper">
    <button
      className="keyword-item"
      onClick={() => insertTagAtMessageSegments("default_message_text", "{first_name}")}
    >
      [First Name]
    </button>
    <button
      className="keyword-item"
      onClick={() => insertTagAtMessageSegments("default_message_text", "{last_name}")}
    >
      [Last Name]
    </button>
    <button
      className="keyword-item"
      onClick={() => insertTagAtMessageSegments("default_message_text", "{group_name}")}
    >
      [Group Name]
    </button>
    <button
      className="keyword-item"
      onClick={() => insertTagAtMessageSegments("default_message_text", "{decline_reason}")}
    >
      [Decline Reason]
    </button>
  </div>
);
}
export default MessageKeywords;
